import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class ProductVariantScales extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('.shopify-section, dialog');

    target?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  #handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const productId = this.dataset.productId;
    const escapedProductId = productId && globalThis.CSS?.escape ? CSS.escape(productId) : productId;
    const replacementSelector =
      escapedProductId != null && escapedProductId !== ''
        ? `product-variant-scales[data-product-id="${escapedProductId}"]`
        : 'product-variant-scales';
    const replacement = event.detail.data.html.querySelector(replacementSelector);

    if (!(replacement instanceof HTMLElement)) {
      this.hidden = true;
      this.innerHTML = '';
      return;
    }

    this.dataset.productId = replacement.dataset.productId || this.dataset.productId || '';
    this.dataset.currentVariantId = replacement.dataset.currentVariantId || event.detail.resource?.id || '';
    this.hidden = replacement.hidden;
    this.innerHTML = replacement.innerHTML;
  };
}

if (!customElements.get('product-variant-scales')) {
  customElements.define('product-variant-scales', ProductVariantScales);
}
